const KEY = "cookie_consent_v1";

export function getConsent() {
  try {
    const raw = localStorage.getItem(KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveConsent(consent) {
  try {
    localStorage.setItem(KEY, JSON.stringify({ ...consent, ts: Date.now() }));
  } catch {
    /* storage unavailable */
  }
}

export function hasAnalyticsConsent() {
  const c = getConsent();
  return Boolean(c && c.analytics);
}

let clarityLoaded = false;

export function initClarity(clarityId) {
  if (clarityLoaded || !clarityId) return;
  clarityLoaded = true;
  (function (c, l, a, r, i, t, y) {
    c[a] = c[a] || function () { (c[a].q = c[a].q || []).push(arguments); };
    t = l.createElement(r); t.async = 1; t.src = "https://www.clarity.ms/tag/" + i;
    y = l.getElementsByTagName(r)[0]; y.parentNode.insertBefore(t, y);
  })(window, document, "clarity", "script", clarityId);
  // Microsoft Clarity Consent Mode V2: analytics granted, advertising never used
  window.clarity("consentv2", { ad_Storage: "denied", analytics_Storage: "granted" });
}

let gaLoaded = false;

// Send a GA4 custom event only when analytics consent was given and GA4 is loaded.
export function trackGAEvent(name, params = {}) {
  if (!gaLoaded || typeof window.gtag !== "function") return;
  window.gtag("event", name, params);
}

export function initGA(measurementId) {
  if (gaLoaded || !measurementId) return;
  gaLoaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = "https://www.googletagmanager.com/gtag/js?id=" + measurementId;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  // Google Consent Mode V2: analytics granted only after user consent; advertising never used
  window.gtag("consent", "update", { ad_storage: "denied", ad_user_data: "denied", ad_personalization: "denied", analytics_storage: "granted" });
  window.gtag("config", measurementId);
}
